import React, { useState } from 'react'
import { usePracticeInterviewing } from './PracticeInterviewingProvider'
import { Button } from '~/lib/ui/button'
import usePipeSDK from '@addpipe/react-pipe-media-recorder'
import { useTranslation } from '../../hooks/useTranslation'

const Question = ({ response, index }) => {
  const {
    saveInterviewResponse,
    current_user,
    eu,
    isMobile,
    uiState,
    setUiState,
    getInterviewResponses,
  } = usePracticeInterviewing()
  const id = 'yns-response-id-' + response.id
  const [showResponseVideoPlayer, setShowResponseVideoPlayer] = useState(
    !response.generalInterviewQuestion,
  )
  const [isDisabled, setIsDisabled] = useState(true)
  const [recorder, setRecorder] = useState(null)

  const { t } = useTranslation('Question')

  const { isLoaded } = usePipeSDK((PipeSDK) => {
    if (isLoaded) return
    const payload = JSON.stringify({
      interview_id: response.documentId,
      response_id: response.id,
      candidate_id: current_user.id,
    })
    const pipeParams = {
      size: { width: 640, height: 390 },
      qualityurl: 'avq/720p.xml',
      accountHash: '279d721a19400c3873908e8241f49f4f',
      eid: eu ? 'dXeplJ' : 'Kq6hjT',
      mrt: 120,
      avrec: !uiState.audioInterview ? 1 : null,
      ao: uiState.audioInterview ? 1 : null,
      countdowntimer: 5,
      payload: payload,
    }

    PipeSDK.insert(
      'yns-response-id-' + response.id,
      pipeParams,
      (pipeRecorder) => {
        setRecorder(pipeRecorder)
        var recorder = PipeSDK.getRecorderById('yns-response-id-' + response.id)

        recorder.onUploadDone = (
          // eslint-disable-next-line no-unused-vars
          recorderId,
          // eslint-disable-next-line no-unused-vars
          streamName,
          // eslint-disable-next-line no-unused-vars
          streamDuration,
          // eslint-disable-next-line no-unused-vars
          audioCodec,
          // eslint-disable-next-line no-unused-vars
          videoCodec,
          // eslint-disable-next-line no-unused-vars
          fileType,
          // eslint-disable-next-line no-unused-vars
          audioOnly,
          // eslint-disable-next-line no-unused-vars
          location,
        ) => {
          setIsDisabled(false)
          if (!uiState.practiceMode) {
            recorder.remove()
          }
        }
        if (isMobile) {
          recorder.onVideoUploadSuccess = (
            // eslint-disable-next-line no-unused-vars
            recorderId,
            // eslint-disable-next-line no-unused-vars
            filename,
            // eslint-disable-next-line no-unused-vars
            filetype,
            // eslint-disable-next-line no-unused-vars
            videoId,
            // eslint-disable-next-line no-unused-vars
            audioOnly,
            // eslint-disable-next-line no-unused-vars
            location,
          ) => {
            setIsDisabled(false)
            if (!uiState.practiceMode) {
              recorder.remove()
            }
          }
        }
      },
    )
  })

  const handleNextQuestion = (document_id) => {
    if (recorder) {
      recorder.remove()
    }
    saveInterviewResponse(document_id)
  }

  const handleBackToForm = async () => {
    setUiState((prev) => ({
      ...prev,
      showForm: true,
      showInterview: false,
      formIndex: 0,
    }))
    await getInterviewResponses(response.documentId)
  }

  const handleViewAll = async () => {
    setUiState((prev) => ({
      ...prev,
      showForm: false,
      showInterview: false,
      activeTab: 'previousPracticeInterviews',
    }))
    await getInterviewResponses(response.documentId)
  }

  const handleEnded = () => {
    setShowResponseVideoPlayer(true)
  }

  return (
    <div className="w-full">
      <p className="mb-4">{t('question_number', { number: index + 1 })}</p>
      <h2 className="mb-4">
        {response.customizedInterviewQuestion ||
          response.generalInterviewQuestion}
      </h2>
      {response.generalInterviewQuestion && (
        <div className="mb-4 flex w-full">
          <video
            className="mx-auto h-[390px] w-[640px] rounded"
            controls
            autoPlay={true}
            controlsList="nodownload"
            onEnded={() => handleEnded()}
          >
            <source src={response.youtubeVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      )}
      <div className={showResponseVideoPlayer ? 'flex w-full' : 'hidden'}>
        <div id={id} className="m-auto"></div>
      </div>
      <div className="mt-4 flex justify-center">
        <Button
          id="save_link"
          onClick={() => handleNextQuestion(response.documentId)}
          disabled={isDisabled}
        >
          {t('save')}
        </Button>
        <Button
          className="ml-4"
          variant="outline"
          onClick={() => handleBackToForm()}
        >
          {t('back')}
        </Button>
        <Button
          className="ml-4"
          variant="outline"
          onClick={() => handleViewAll()}
        >
          {t('view')}
        </Button>
      </div>
    </div>
  )
}

export default Question
